module.exports = __webpack_public_path__ + "assets/img/Singapore Botanic Gardens.33c35eef.jpg";